import styled, { keyframes } from "styled-components";
import { px2rem } from "common/helpers/rem";
import Icon from "common/icons";
import PACK from "common/icons/packs";

export const LoadMoreThreads = styled.button.attrs({
  type: "button",
})`
  display: block;
  line-height: ${px2rem(50)};
  height: ${px2rem(50)};
  width: 100%;
  color: ${props => props.theme.grey800};
  font-weight: ${props => props.theme.weightBold};
  text-align: left;
  font-size: ${px2rem(12)};
  padding: 0 ${px2rem(16)};
`;
LoadMoreThreads.displayName = "LoadMoreThreads";

const bounceKeyframe = keyframes`
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.5, 1.5, 1.5);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;

export const Like = styled(Icon).attrs(() => ({
  icon: PACK.POST_SHOW_ACTION_BAR.LIKE_EMPTY,
}))`
  display: inline-block;
  vertical-align: top;
`;

export const LikeActive = styled(Icon).attrs(() => ({
  icon: PACK.POST_SHOW_ACTION_BAR.LIKE_FULL,
}))`
  display: inline-block;
  vertical-align: top;

  animation-name: ${bounceKeyframe};
  animation-fill-mode: both;
  animation-duration: 0.75s;
`;

export const AndDot = styled.span`
  &::before {
    content: "·";
  }
  margin: 0 ${px2rem(4)};
`;
